export enum UserRoles {
  Seller = "Seller",
  Buyer = "Buyer",
  Escrow = "Escrow",
  Other = "Other",
}
